import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { EPartners } from '~/features/partners/models'

const useIsPartner = () => {
  const { partner } = usePartnerCentralized()

  const isPartner =
    !!partner?.partnerName && partner?.partnerName !== EPartners.heyLibby

  return isPartner
}

export default useIsPartner
